import SpinnerIcon from "./icons/SpinnerIcon"

export default function Loading() {
  return (
    <div className="flex justify-center items-center min-h-[600px]">
      <SpinnerIcon />
    </div>
  )
}